import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  FacebookIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import twitterLogo from "../../../../images/x-logo.svg";

const Share = ({ shareLink, setSharePopup, setShareLink }) => {
  // t
  const { t } = useTranslation();

  // close
  const handleClose = () => {
    setSharePopup(false);
    setShareLink(null);
  };

  // copy
  const [copied, setCopied] = useState(false);

  const handleCopy = (qrCode) => {
    navigator.clipboard.writeText(qrCode).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <div className="backdrop">
      <div className="share-popup">
        {/* Close Button */}
        <div className="share-close-btn" onClick={handleClose}>
          &times;
        </div>

        {/* Link Box with Copy Button */}
        <div className="share-link-box">
          <input
            type="text"
            value={shareLink}
            readOnly
            className="share-link-input"
          />
          <div className="copy-container">
            <button className="copy-btn" onClick={() => handleCopy(shareLink)}>
              {t("pledge.copy")}
            </button>

            {copied && (
              <span className="copied-message">{t("pledge.text_copied")}</span>
            )}
          </div>
        </div>

        {/* body */}
        <div className="share-body">
          <FacebookShareButton url={shareLink} onClick={handleClose}>
            <FacebookIcon size={32} round />
          </FacebookShareButton>

          {/* <FacebookMessengerShareButton url={shareLink} onClick={handleClose}>
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton> */}

          <TwitterShareButton url={shareLink} onClick={handleClose}>
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                overflow: "hidden",
              }}
            >
              <img
                src={twitterLogo}
                alt="X Logo"
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          </TwitterShareButton>

          <WhatsappShareButton url={shareLink} onClick={handleClose}>
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>

          <LinkedinShareButton url={shareLink} onClick={handleClose}>
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>

        {/* footer */}
        <footer>
          <button type="button" onClick={handleClose}>
            {t("pledge.close")}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default Share;
